import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: '.drag-handle',
      animation: 150,
      ghostClass: 'bg-slate-100',
      onEnd: this.#save.bind(this)
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  #save() {
    const ids = [...this.element.querySelectorAll('[data-row-id]')].map(el => el.dataset.rowId)
    const search = new URLSearchParams(window.location.search)

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        ids,
        page:     search.get('page')     || '1',
        per_page: search.get('per_page') || '25'
      })
    })
  }
}
